module.exports = __webpack_public_path__ + "img/section2_item4.152cc042.svg";